import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { AlertInfo } from "../../UI/StandardAlerts/StandardAlerts";
import PersonLoaderWorkflowNodeDefinitionForm, { PERSON_LOADER_GET_CRITERIA, PERSON_LOADER_GET_FORM_STATE, } from "./forms/PersonLoaderWorkflowNodeDefinitionForm";
import CreateEmailWorkflowNodeDefinitionForm, { CREATE_EMAIL_GET_CRITERIA, CREATE_EMAIL_GET_FORM_STATE, } from "./forms/CreateEmailWorkflowNodeDefinitionForm";
import ChangeStageWorkflowNodeDefinitionForm, { CHANGE_STAGE_GET_CRITERIA, CHANGE_STAGE_GET_FORM_STATE, } from "./forms/ChangeStageWorkflowNodeDefinitionForm";
import EnrollInCampaignWorkflowNodeDefinitionForm, { ENROLL_IN_CAMPAIGN_GET_CRITERIA, ENROLL_IN_CAMPAIGN_GET_FORM_STATE, } from "./forms/EnrollInCampaignWorkflowNodeDefinitionForm";
import TextField from "../../Form/TextField";
import WaitForMessageSendWorkflowNodeDefinitionForm, { WAIT_FOR_MESSAGE_SEND_GET_CRITERIA, WAIT_FOR_MESSAGE_SEND_GET_FORM_STATE, } from "./forms/WaitForMessageSendWorkflowNodeDefinitionForm";
import CreateSmsWorkflowNodeDefinitionForm, { CREATE_SMS_GET_CRITERIA, CREATE_SMS_GET_FORM_STATE, } from "./forms/CreateSmsWorkflowNodeDefinitionForm";
import ChangeAssigneeWorkflowNodeDefinitionForm, { CHANGE_ASSIGNEE_GET_CRITERIA, CHANGE_ASSIGNEE_GET_FORM_STATE, } from "./forms/ChangeAssigneeWorkflowNodeDefinitionForm";
import WaitForSurveyReceivedWorkflowNodeDefinitionForm, { WAIT_FOR_SURVEY_RECEIVED_GET_CRITERIA, WAIT_FOR_SURVEY_RECEIVED_GET_FORM_STATE, } from "./forms/WaitForSurveyReceivedWorkflowNodeDefinitionForm";
import WaitForApplicationWorkflowNodeDefinitionForm, { WAIT_FOR_APPLICATION_GET_CRITERIA, WAIT_FOR_APPLICATION_GET_FORM_STATE, } from "./forms/WaitForApplicationWorkflowNodeDefinitionForm";
import WaitForEnrollmentWorkflowNodeDefinitionForm, { WAIT_FOR_ENROLLMENT_GET_CRITERIA, WAIT_FOR_ENROLLMENT_GET_FORM_STATE, } from "./forms/WaitForEnrollmentWorkflowNodeDefinitionForm";
import SendSurveyWorkflowNodeDefinitionForm, { SEND_SURVEY_GET_CRITERIA, SEND_SURVEY_GET_FORM_STATE, } from "./forms/SendSurveyWorkflowNodeDefinitionForm";
import WaitForTagAppliedWorkflowNodeDefinitionForm, { WAIT_FOR_TAG_APPLIED_GET_CRITERIA, WAIT_FOR_TAG_APPLIED_GET_FORM_STATE, } from "./forms/WaitForTagAppliedWorkflowNodeDefinitionForm";
export const WORKFLOW_NODE_FORM_CONFIG = {
    ChangeStage: {
        form: ChangeStageWorkflowNodeDefinitionForm,
        getCriteriaAndDelegates: CHANGE_STAGE_GET_CRITERIA,
        getFormState: CHANGE_STAGE_GET_FORM_STATE,
    },
    CreateEmail: {
        form: CreateEmailWorkflowNodeDefinitionForm,
        getCriteriaAndDelegates: CREATE_EMAIL_GET_CRITERIA,
        getFormState: CREATE_EMAIL_GET_FORM_STATE,
    },
    CreateSms: {
        form: CreateSmsWorkflowNodeDefinitionForm,
        getCriteriaAndDelegates: CREATE_SMS_GET_CRITERIA,
        getFormState: CREATE_SMS_GET_FORM_STATE,
    },
    EnrollInCampaign: {
        form: EnrollInCampaignWorkflowNodeDefinitionForm,
        getCriteriaAndDelegates: ENROLL_IN_CAMPAIGN_GET_CRITERIA,
        getFormState: ENROLL_IN_CAMPAIGN_GET_FORM_STATE,
    },
    WaitForMessageSend: {
        form: WaitForMessageSendWorkflowNodeDefinitionForm,
        getCriteriaAndDelegates: WAIT_FOR_MESSAGE_SEND_GET_CRITERIA,
        getFormState: WAIT_FOR_MESSAGE_SEND_GET_FORM_STATE,
    },
    WaitForSurveyReceived: {
        form: WaitForSurveyReceivedWorkflowNodeDefinitionForm,
        getCriteriaAndDelegates: WAIT_FOR_SURVEY_RECEIVED_GET_CRITERIA,
        getFormState: WAIT_FOR_SURVEY_RECEIVED_GET_FORM_STATE,
    },
    PersonLoader: {
        form: PersonLoaderWorkflowNodeDefinitionForm,
        getCriteriaAndDelegates: PERSON_LOADER_GET_CRITERIA,
        getFormState: PERSON_LOADER_GET_FORM_STATE,
    },
    ChangeAssignee: {
        form: ChangeAssigneeWorkflowNodeDefinitionForm,
        getCriteriaAndDelegates: CHANGE_ASSIGNEE_GET_CRITERIA,
        getFormState: CHANGE_ASSIGNEE_GET_FORM_STATE,
    },
    ApplicationStatusChangeEventWait: {
        form: WaitForApplicationWorkflowNodeDefinitionForm,
        getCriteriaAndDelegates: WAIT_FOR_APPLICATION_GET_CRITERIA,
        getFormState: WAIT_FOR_APPLICATION_GET_FORM_STATE,
    },
    EnrollmentStatusChangeEventWait: {
        form: WaitForEnrollmentWorkflowNodeDefinitionForm,
        getCriteriaAndDelegates: WAIT_FOR_ENROLLMENT_GET_CRITERIA,
        getFormState: WAIT_FOR_ENROLLMENT_GET_FORM_STATE,
    },
    SendSurvey: {
        form: SendSurveyWorkflowNodeDefinitionForm,
        getCriteriaAndDelegates: SEND_SURVEY_GET_CRITERIA,
        getFormState: SEND_SURVEY_GET_FORM_STATE,
    },
    WaitForTagApplied: {
        form: WaitForTagAppliedWorkflowNodeDefinitionForm,
        getCriteriaAndDelegates: WAIT_FOR_TAG_APPLIED_GET_CRITERIA,
        getFormState: WAIT_FOR_TAG_APPLIED_GET_FORM_STATE,
    },
};
const WorkflowNodeForm = ({ nodeType, name, pipelineId, virtualizedAppName, }) => {
    var _a;
    const NodeForm = (_a = WORKFLOW_NODE_FORM_CONFIG[nodeType.id]) === null || _a === void 0 ? void 0 : _a.form;
    if (!NodeForm) {
        return (_jsx(AlertInfo, { message: "This form could not be displayed", detail: `nodeType: ${nodeType.id}` }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(TextField, { name: name + ".meta.name", required: true, label: "Action Name" }), _jsx(TextField, { name: name + ".meta.description", label: "Action Description" }), _jsx("hr", {}), _jsx(NodeForm, { name: name + ".criteria", pipelineId: pipelineId, virtualizedAppName: virtualizedAppName })] }));
};
export default WorkflowNodeForm;
